import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import config from "../../../../utils/config/config";
import { memo } from "react";
import { getAppVersion } from "../../../../utils/version.mjs";


const SideFooter = ({
  isMobile,
  isSideBar,
  handleAssistantBotNavigate,
  selectedDomainDetails,
}) => {
  const selectedAssistantBot = selectedDomainDetails?.assistantBotConfig;
  const isAssistantBotOpen = useSelector((state) => state.bot.isAssistantBotOpen);
  const showFooter = !isMobile && !isSideBar;
  const [appVersion, setAppVersion] = useState(null);

  useEffect(() => {
    getAppVersion().then(version => {
      setAppVersion(version);
    });
  }, []);

  if (!showFooter) return null;

  return (
    <>
      {/* Assistant Bot */}
      {selectedAssistantBot && (
        <div
          className={`flex items-center px-4 py-[11px] cursor-pointer rounded transition-colors duration-150
            ${isAssistantBotOpen
              ? "bg-purple-100 text-primary-blue font-medium"
              : "hover:bg-purple-100 hover:text-primary-blue"
            }`}
          onClick={handleAssistantBotNavigate}
        >
          <img
            src={`${config?.contentURL}${selectedAssistantBot?.logoUrl}`}
            alt={selectedAssistantBot?.name || "Assistant Bot"}
            className="w-[20px] object-contain rounded mr-3"
          />
          <span className="text-size-12 font-medium">
            {selectedAssistantBot?.name || "Assistant Bot"}
          </span>
        </div>
      )}

      {/* Build Label */}
      <span className="text-[#8C8C8C] font-semibold rounded-full py-1 px-3 text-[12px] border border-purple-300 w-fit mx-auto mt-6 cursor-not-allowed">
        {appVersion ? `Build v${appVersion}` : 'Build v394'}
      </span>
    </>
  );
};

export default memo(SideFooter);
